import { Component } from '@theme/component';

/**
 * @typedef {Object} BackInStockSignupRefs
 * @property {HTMLButtonElement} [toggle]
 * @property {HTMLElement} [fields]
 * @property {HTMLInputElement} [email]
 */

/**
 * Back-in-stock signup for out-of-stock variants (snippets/curaprox-back-in-stock.liquid).
 * The "Notify me when available" button swaps itself for the email form; the form itself
 * is a plain `{% form 'customer' %}` post, so no further JS is involved.
 *
 * @extends {Component<BackInStockSignupRefs>}
 */
class BackInStockSignup extends Component {
  reveal() {
    const { toggle, fields, email } = this.refs;
    if (!toggle || !fields) return;

    toggle.hidden = true;
    toggle.setAttribute('aria-expanded', 'true');
    fields.hidden = false;
    email?.focus();
  }
}

if (!customElements.get('back-in-stock-signup')) {
  customElements.define('back-in-stock-signup', BackInStockSignup);
}
